/*
 * Google Ads — seguimiento de conversiones por clic en WhatsApp.
 *
 * Conversión: clic en cualquier <a> cuyo href contenga "wa.me" o "api.whatsapp.com"
 * (botones tipo "COTIZA MAYOREO", icono flotante, enlaces en footer/hero, etc.).
 *
 * Usa delegación de eventos en `document`, por lo que también funciona con
 * botones cargados dinámicamente (cart drawer, quick add, secciones del editor, etc.).
 */
(function () {
  'use strict';

  var SEND_TO = 'AW-17045702295/3fqeCMLslsQcEJeNg8A_';
  var FALLBACK_MS = 800;

  function isWhatsAppHref(href) {
    if (!href) return false;
    return href.indexOf('wa.me') !== -1 || href.indexOf('api.whatsapp.com') !== -1;
  }

  function fireConversion(callback) {
    // Si gtag aún no está disponible, no bloqueamos la navegación.
    if (typeof window.gtag !== 'function') {
      if (typeof callback === 'function') callback();
      return;
    }

    window.gtag('event', 'conversion', {
      send_to: SEND_TO,
      event_callback: callback
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      // Respetar clics con modificadores (abrir en pestaña/ventana nueva del navegador)
      // o que no sean clic principal: dejamos pasar sin prevenir la navegación.
      var nativeNewTab =
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey;

      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!isWhatsAppHref(href)) return;

      var opensInNewTab = link.target === '_blank' || nativeNewTab;

      if (opensInNewTab) {
        // Pestaña nueva: NO prevenimos la navegación. WhatsApp abre en otra pestaña
        // y esta página sigue viva para registrar el evento.
        fireConversion();
        return;
      }

      // Misma pestaña: prevenimos temporalmente, registramos la conversión y
      // redirigimos en el callback. setTimeout de respaldo por si el callback no llega.
      event.preventDefault();

      var destination = link.href; // URL absoluta resuelta
      var navigated = false;

      function go() {
        if (navigated) return;
        navigated = true;
        window.location.href = destination;
      }

      fireConversion(go);
      window.setTimeout(go, FALLBACK_MS);
    },
    // Captura en true para detectar el clic aunque algún handler haga stopPropagation.
    true
  );
})();
